import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { API, useAuth } from "@/context/AuthContext";

const SiteCtx = createContext(null);

const STORAGE_KEY = "mss.activeSite";

export function SiteProvider({ children }) {
  const { user } = useAuth();
  const [sites, setSites] = useState([]);
  const [activeSiteId, setActiveSiteIdState] = useState("all");
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    if (!user) return;
    setLoading(true);
    try {
      const { data } = await axios.get(`${API}/sites`);
      setSites(data);
      // aktif şantiye seçimi
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved && (saved === "all" || data.some((s) => s.id === saved))) {
        setActiveSiteIdState(saved);
      } else if (data.length === 1) {
        setActiveSiteIdState(data[0].id);
        localStorage.setItem(STORAGE_KEY, data[0].id);
      } else {
        setActiveSiteIdState("all");
      }
    } catch { /* ignore */ }
    finally { setLoading(false); }
  }, [user]);

  useEffect(() => { load(); }, [load]);

  const setActiveSiteId = (id) => {
    setActiveSiteIdState(id);
    localStorage.setItem(STORAGE_KEY, id);
  };

  const activeSite = sites.find((s) => s.id === activeSiteId) || null;

  // API params helper — tüm sayfalar bu şekilde site filtresi ekler
  const siteParams = () => activeSiteId && activeSiteId !== "all" ? { site_id: activeSiteId } : {};

  return (
    <SiteCtx.Provider value={{ sites, activeSiteId, activeSite, setActiveSiteId, siteParams, reloadSites: load, loading }}>
      {children}
    </SiteCtx.Provider>
  );
}

export const useSites = () => useContext(SiteCtx);
